import React from 'react';
import { AuthService } from '../services/authService';
import './PendingApprovalPage.css';

export const PendingApprovalPage: React.FC = () => {
  const handleLogout = async () => {
    await AuthService.logout();
  };

  return (
    <div className="pending-approval-wrapper">
      <div className="pending-approval-container">
        <div className="pending-approval-card">
          <div className="pending-icon">
            <svg width="64" height="64" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <circle cx="12" cy="12" r="10" stroke="#f59e0b" strokeWidth="2"/>
              <path d="M12 6v6l4 2" stroke="#f59e0b" strokeWidth="2" strokeLinecap="round"/>
            </svg>
          </div>

          <h1 className="pending-title">Access Pending Approval</h1>

          <p className="pending-message">
            Your account has been created and is awaiting approval from a system administrator.
          </p>

          {/* Prominent notice banner */}
          <div className="pending-notice-banner">
            <div className="notice-icon">📋</div>
            <div className="notice-content">
              <h3>Check Back Later</h3>
              <p>Your access request is being reviewed. Please check back later or contact your manager if you need immediate access to the system.</p>
            </div>
          </div>

          <p className="pending-submessage">
            You will receive access to the application once an administrator approves your account.
          </p>

          <div className="pending-actions">
            <button className="logout-button" onClick={handleLogout}>
              Sign Out
            </button>
          </div>

          <div className="pending-footer">
            <p>Need help? Contact your system administrator</p>
          </div>
        </div>
      </div>
    </div>
  );
};
